import {CreateAccessor, GetDocs, GetDoc} from "mobx-graphlink";
import {Scene} from "./scenes/@Scene";

export const GetScenes = CreateAccessor((): Scene[]=>{
	return GetDocs({}, a=>a.scenes).map(a=>a?.Cast(Scene));
});
export const GetScene = CreateAccessor((id: string|n): Scene|n=>{
	return GetDoc({}, a=>a.scenes.get(id!))?.Cast(Scene);
});